export default __webpack_public_path__ + "static/media/5_1.0565f467.jpg";